import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { Project } from 'src/app/shared/models/project';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { UdlModelService } from '../udl-model.service';
import { EPAProjectRunService } from './project-status/esa-project-run.api.service';

@Component({
    selector: 'app-esa-output-project',
    templateUrl: 'esa-output.component.html',
    styleUrls: ['esa-output.component.css']
})
export class EASOutputProjectComponent implements OnInit {
    public modelService: UdlModelService = inject(UdlModelService);
    private projectRunService: EPAProjectRunService = inject(EPAProjectRunService);
    @Input() selectedProject: Project = {} as Project;
    
    loading: boolean = false;
    destroyRef = inject(DestroyRef)
    public isSummaryReportAvailable: boolean = false;

    ngOnInit(): void {
        this.projectRunService.getRunStatus();
    }

    onSummaryReportAvailable(event: boolean): void {
        this.isSummaryReportAvailable = event;
    }

    setLoadingState(state: boolean): void {
        this.loading = state;
    }

    onSeletedModelChange({ value }: DropdownChangeEvent): void {
        this.modelService.model = value;
    }
}